import styled from "styled-components";

export const KnownIssuesHeader = styled.div`
  display: flex;
  padding: 8px;
  margin-bottom: 6px;
`;
